"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../controllers/BaseController");
var DlgNumericEditorCtl = /** @class */ (function (_super) {
    __extends(DlgNumericEditorCtl, _super);
    function DlgNumericEditorCtl() {
        return _super.call(this, true) || this;
    }
    DlgNumericEditorCtl.prototype.ResetData = function () {
        this.DATA = {
            onClose: null,
            onYes: null,
            visible: false,
            title: "",
            value: 0,
            minValue: 0,
            maxValue: 0,
            digitsCount: 0,
            inputCaption: "",
            inputPlaceHolder: ""
        };
    };
    DlgNumericEditorCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgNumericEditorCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgNumericEditorCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgNumericEditorCtl.prototype.SetValue = function (val, needUpdate) {
        this.DATA.value = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    DlgNumericEditorCtl.prototype.SetMinValue = function (val, needUpdate) {
        this.DATA.minValue = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    DlgNumericEditorCtl.prototype.SetMaxValue = function (val, needUpdate) {
        this.DATA.maxValue = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    DlgNumericEditorCtl.prototype.SetDigitsCountValue = function (val, needUpdate) {
        this.DATA.digitsCount = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    DlgNumericEditorCtl.prototype.SetTitle = function (val, needUpdate) {
        this.DATA.title = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    DlgNumericEditorCtl.prototype.SetInputCaption = function (val, needUpdate) {
        this.DATA.inputCaption = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    DlgNumericEditorCtl.prototype.SetInputPlaceHolder = function (val, needUpdate) {
        this.DATA.inputPlaceHolder = val;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    DlgNumericEditorCtl.prototype.SetOnCloseClick = function (callback, needUpdate) {
        this.DATA.onClose = callback;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    DlgNumericEditorCtl.prototype.SetOnYesClick = function (callback, needUpdate) {
        this.DATA.onYes = callback;
        if (needUpdate) {
            this.Update();
        }
        return this;
    };
    return DlgNumericEditorCtl;
}(BaseController_1.BaseController));
exports.DlgNumericEditorCtl = DlgNumericEditorCtl;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ctl/DlgNumericEditorCtl.ts
// module id = 907
// module chunks = 0